import {
    IDashboardResponse,
    IFavoriteResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { Filter } from 'utils/query_v3';

type DashboardFilterProps = Readonly<{
    corporationId: string | undefined;
    locationId: string | undefined;
}>;

export const getDashboardFilter = ({
    corporationId,
    locationId,
}: DashboardFilterProps) => {
    const type = locationId ? 'Location' : 'Corporation';
    return Filter.and(
        Filter.in('DashboardTypeName', [type, `${type}PowerBI`]),
        locationId ? Filter.eq('LocationId', locationId) : undefined,
        corporationId ? Filter.eq('CorporationId', corporationId) : undefined
    );
};

export enum DashboardTabs {
    AllDashboards = 0,
    FavoriteDashboards = 1,
}

// TODO: this causes the paging to be super wonky when showing only favorites. It would
// be much better for favorite to be a filterable property on IDashboardResponse instead.
export const getDashboardsToDisplay = (
    tab: DashboardTabs,
    dashboards: IDashboardResponse[] | undefined,
    favorites: IFavoriteResponse[] | undefined
) =>
    tab === DashboardTabs.FavoriteDashboards
        ? dashboards?.filter(
              (d) =>
                  favorites?.findIndex((favorite) => favorite.FavoriteId === d.Id) !== -1
          ) ?? []
        : dashboards ?? [];

const GuidPattern = '[0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}';
const PowerBiUrlPattern = `https[:]\\/\\/app.powerbi.com\\/groups\\/${GuidPattern}\\/reports\\/${GuidPattern}`;
const StartsWithPowerBiUrlRegex = new RegExp(`^(${PowerBiUrlPattern})`);
const ValidPowerBiUrlRegex = new RegExp(`^${PowerBiUrlPattern}$`);

export function normalizePowerBiDashboardUrl(url: string) {
    const match = StartsWithPowerBiUrlRegex.exec(url.trim());
    return match && 1 in match ? match[1] : url;
}

export function isPowerBiUrlValid(url: string) {
    return ValidPowerBiUrlRegex.test(url);
}

export const powerBiDashboardUrlValidation = {
    validate: (value: string | undefined): string | undefined => {
        const trimmedValue = normalizePowerBiDashboardUrl(value?.trim() ?? '');

        return !trimmedValue || !isPowerBiUrlValid(trimmedValue)
            ? 'Please enter a published Sentry Dashboard URL.'
            : undefined;
    },
};
